import React from 'react';
import classNames from 'classnames';
import './Spinner.less';

export interface ISpinnerProps extends React.ComponentProps<'div'> {
  /**
   * Spinner size
   */
  size?: number | string;
  /**
   * Spinner color
   */
  color?: string;
}

const defaultSize = 60;

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function Spinner({ size, color, className, ...otherProps }: ISpinnerProps) {
  return (
    <div
      className={classNames('dp-spinner', className)}
      role="progressbar"
      style={{
        width: size ?? defaultSize,
        height: size ?? defaultSize,
      }}
      {...otherProps}
    >
      <svg viewBox="20 20 40 40">
        <circle cx="40" cy="40" r="18.2" strokeWidth="3.6" fill="none" style={{ stroke: color }} />
      </svg>
    </div>
  );
}

